import { memo } from 'react';

import TinderLogo from 'Assets/reactSvgs/TinderLogo';

import TopNavBase from './Base';

type Props = {
  startComponent?: React.ReactElement;
  endComponent?: React.ReactElement;
};

const defaultStartComponent = (
  <TinderLogo className="H(24px) Mx(12px) Pos(a) Start(0)" type="pink" />
);

const TopNav = (props: Props) => {
  const { startComponent = defaultStartComponent, endComponent } = props;
  return <TopNavBase startComponent={startComponent} endComponent={endComponent} />;
};

export default memo(TopNav);
